<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>统计管理</el-breadcrumb-item>
        <el-breadcrumb-item>统计分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="供应点分析" name="supplyAnalysis">
          <el-row :gutter="24">
            <el-col :span="24">
              <div id="supplyAnalysis" class="canvas-box" v-loading="canvasLoading"></div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="基地分析" name="baseAnalysis">
          <el-row :gutter="24">
            <el-col :span="24">
              <div id="baseAnalysis" class="canvas-box" v-loading="canvasLoading"></div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="畅销分析" name="salesAnalysis">
          <el-row :gutter="24">
            <el-col :span="12">
              <div id="bestSales" class="canvas-box" v-loading="canvasLoading"></div>
            </el-col>
            <el-col :span="12">
              <div id="worstSales" class="canvas-box" v-loading="canvasLoading"></div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      supplyId: "",
      activeName: "supplyAnalysis",
      canvasLoading: false,
      bestSalesData: {
        info: {
          id: "bestSales",
          title: "最畅销菜品",
        },
      },
      worstSalesData: {
        info: {
          id: "worstSales",
          title: "最不畅销菜品",
        },
      },
      supplyAnalysisData: {
        info: {
          id: "supplyAnalysis",
          title: "供应点分析",
        },
      },
      baseAnalysisData: {
        info: {
          id: "baseAnalysis",
          title: "基地分析",
        },
      },
    };
  },
  mounted() {
    this.supplyId = this.$route.params.supplyId;
    this.loadSupplyEcharts();
  },
  methods: {
    /**
     * 加载畅销Echarts表数据
     * @param type
     */
    loadSalesEcharts() {
      this.canvasLoading = true;
      this.$http({
        url: global.apiUrl + "/statistic/sale/list",
        method: "GET",
        params: {
          supplyId: this.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.canvasLoading = false;
            const body = res.body;
            if (res.body.data) {
              Object.assign(this.bestSalesData, body.data.saleBest);
              this.drawSalesAnalysis(this.bestSalesData);
              Object.assign(this.worstSalesData, body.data.saleLast);
              this.drawSalesAnalysis(this.worstSalesData);
            }
          } else {
            this.canvasLoading = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * tab switch事件
     * @param tab
     * @param e
     */
    handleClick(tab, e) {
      switch (this.activeName) {
        case "salesAnalysis":
          setTimeout(() => {
            this.loadSalesEcharts();
          }, 500);
          break;
        case "supplyAnalysis":
          this.canvasLoading = true;
          setTimeout(() => {
            this.canvasLoading = false;
            this.loadSupplyEcharts();
          }, 1000);
          break;
        case "baseAnalysis":
          this.canvasLoading = true;
          setTimeout(() => {
            this.canvasLoading = false;
            this.loadBaseEcharts();
          }, 1000);
          break;
      }
    },
    /**
     * 加载供应点Echarts表数据
     */
    loadSupplyEcharts() {
      this.canvasLoading = true;
      this.$http({
        url: global.apiUrl + "/statistic/supply/list",
        method: "GET",
        params: {
          supplyId: this.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.canvasLoading = false;
            if (res.body.data) {
              Object.assign(this.supplyAnalysisData, res.body.data);
              this.drawSupplyAnalysis(this.supplyAnalysisData);
            }
          } else {
            this.canvasLoading = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载基地Echarts表数据
     */
    loadBaseEcharts() {
      this.canvasLoading = true;
      this.$http({
        url: global.apiUrl + "/statistic/farm/list",
        method: "GET",
        params: {
          supplyId: this.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.canvasLoading = false;
            if (res.body.data) {
              Object.assign(this.baseAnalysisData, res.body.data);
              this.drawBaseAnalysis(this.baseAnalysisData);
            }
          } else {
            this.canvasLoading = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 构建畅销分析Echarts表
     * @param resData
     */
    drawSalesAnalysis(resData) {
      const myChart = echarts.init(document.getElementById(resData.info.id));
      const app = {};
      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function () {
          const labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance,
            },
          };
          myChart.setOption({
            series: [
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
            ],
          });
        },
      };

      const labelOption = {
        normal: {
          show: true,
          position: app.config.position,
          distance: app.config.distance,
          align: app.config.align,
          verticalAlign: app.config.verticalAlign,
          rotate: app.config.rotate,
          formatter: "{c}  {name|{a}}",
          fontSize: 16,
          rich: {
            name: {
              textBorderColor: "#fff",
            },
          },
        },
      };
      const option = {
        title: {
          text: resData.info.title,
        },
        color: resData.color,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: 60,
          right: 10,
          bottom: 100,
        },
        legend: {
          data: resData.legend.data,
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: resData.xaxis,
            axisLabel: {
              rotate: 50,
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: resData.series[0].name,
            type: "bar",
            barGap: 0,
            label: labelOption,
            data: resData.series[0].data,
          },
          {
            name: resData.series[1].name,
            type: "bar",
            label: labelOption,
            data: resData.series[1].data,
          },
        ],
      };
      myChart.setOption(option);
    },
    /**
     * 构建供应点分析Echarts表
     * @param resData
     */
    drawSupplyAnalysis(resData) {
      const myChart = echarts.init(document.getElementById(resData.info.id));
      window.onresize = myChart.resize();
      const option = {
        title: {
          text: resData.info.title,
        },
        color: ["#2f8c0c", "#e5323e", "#44c610", "#ff963d"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: resData.legend.data,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: resData.xaxis,
            axisLabel: {
              rotate: 50,
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: resData.series[0].name,
            type: "line",
            stack: "总量",
            areaStyle: { normal: {} },
            data: resData.series[0].data,
          },
          {
            name: resData.series[1].name,
            type: "line",
            stack: "总量",
            areaStyle: { normal: {} },
            data: resData.series[1].data,
          },
          {
            name: resData.series[2].name,
            type: "line",
            stack: "总量",
            areaStyle: { normal: {} },
            data: resData.series[2].data,
          },
          {
            name: resData.series[3].name,
            type: "line",
            stack: "总量",
            areaStyle: { normal: {} },
            data: resData.series[3].data,
          },
        ],
      };
      myChart.setOption(option);
    },
    /**
     * 构建基地分析Echarts表
     * @param resData
     */
    drawBaseAnalysis(resData) {
      const myChart = echarts.init(document.getElementById(resData.info.id));
      window.onresize = myChart.resize();
      const app = {};
      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
      };

      const labelOption = {
        normal: {
          show: true,
          position: app.config.position,
          distance: app.config.distance,
          align: app.config.align,
          verticalAlign: app.config.verticalAlign,
          rotate: app.config.rotate,
          formatter: "{c}  {name|{a}}",
          fontSize: 16,
          rich: {
            name: {
              textBorderColor: "#fff",
            },
          },
        },
      };

      const option = {
        title: {
          text: resData.info.title,
        },
        color: resData.color,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: 60,
          right: 10,
          bottom: 100,
        },
        legend: {
          data: resData.legend.data,
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            axisLabel: {
              rotate: 50,
              interval: 0,
            },
            data: resData.xaxis,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: resData.series[0].name,
            type: "bar",
            barGap: 0,
            label: labelOption,
            data: resData.series[0].data,
          },
          {
            name: resData.series[1].name,
            type: "bar",
            label: labelOption,
            data: resData.series[1].data,
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.hx-form-container {
  .canvas-box {
    width: 100%;
    height: 600px;
  }
}
</style>
